/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { CatastralUnitResource } from '../model/models';
import { GetCatastralUnitsFilterParameter } from '../model/models';
import { InlineObject } from '../model/models';
import { InlineObject1 } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface CatastralUnitServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * List of catastral units
     * 
     * @param perPage 
     * @param page 
     * @param filter 
     */
    getCatastralUnits(perPage?: number, page?: number, filter?: GetCatastralUnitsFilterParameter, extraHttpRequestParams?: any): Observable<Array<CatastralUnitResource>>;

}
